module.exports = __webpack_public_path__ + "img/tu_file_jpeg.a973b2f1.svg";